<template>
  <div class="modal_blocked">
    <div style="text-align: center;">
      <span v-if="!simcard.blocked" class="block"> {{ translate('esim_profile.ask_block') }} </span>
      <span v-else class="block"> {{ translate('esim_profile.ask_unblock') }} </span>
    </div>
    <div style="text-align: center; padding: 15px;">
      <div class="form-group">
        <label v-if="!simcard.blocked" >{{ translate('esim_profile.ask_block_message') }}</label>
        <label v-else >{{ translate('esim_profile.ask_unblock_message') }}</label>
        <textarea
          v-model="message"
          rows="3"
          class="form-control border-input"
        />
      </div>
    </div>
    <div class="text-center">
      <button
        type="submit"
        class="btn btn-info btn-fill btn-wd marginButton"
        @click.prevent="setBlockedEsim"
      >
        {{ translate('yes') }}
      </button>

      <button
        type="submit"
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('no') }}
      </button>
    </div>
  </div>

</template>
<script>

export default {
  props: ['new_status', 'simcard'],

  data () {
    return {
      message: ''
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    setBlockedEsim(){
      this.$http.simcard.setBlockedEsim(this.simcard.id, {blocked: this.new_status, message: this.message },() => {
        this.simcard.blocked = this.new_status

        let message
        if (this.new_status === 1) {
          message = this.translate('esim_profile.blocked_use')
        }else{
          message = this.translate('esim_profile.unblocked_use')
        }

        this.global_notify('info', message)
        this.$emit('update')

        this.cancel()
      })
    }

  }
}

</script>

<style lang='scss'>
  .modal_blocked{
    padding: 10px 0;
  }
  .marginButton {
    margin: 5px;
  }
  .v-spinner {
    margin-bottom: 10px;
  }
  .tdFont {
    font-weight: bold;
  }
  .block {
    text-align: right;
  }

</style>
